import { ReactNode } from 'react';
import { Grid } from '@mui/material';
import { EventItemHeader } from './EventItemHeader';
import { EventItemContent } from './EventItemContent';
import { EventItemText } from './EventItemText';
import { EventItemCircle } from './EventItemCircle';
import { EventItemRow } from './EventItemRow';
import { EventItemColumn } from './EventItemColumn';
import { EventItemActionButton } from './EventItemActionButton';

const Root = ({ children }: { children: ReactNode }) => {
  return (
    <Grid
      sx={{
        background: '#F3F4F9',
        padding: '8px 12px',
        borderRadius: '8px',
      }}
    >
      {children}
    </Grid>
  );
};

export const EventItem = {
  Root,
  Header: EventItemHeader,
  Content: EventItemContent,
  Text: EventItemText,
  Circle: EventItemCircle,
  Row: EventItemRow,
  Column: EventItemColumn,
  ActionButton: EventItemActionButton,
};
